module.exports = __webpack_public_path__ + "static/media/1040.b8cdc1eb.png";